(function wra_book_now() {

  const $accommodation = document.getElementById('accommodation');
  const urlParams = new URLSearchParams(window.location.search);
  const accommodationIdParam = urlParams.get('a');

  window.wra_accos && window.wra_accos.forEach(i => {
    const {id, title} = i;
    $accommodation.options[$accommodation.options.length] = new Option(title, title);
    if (Number(id) === Number(accommodationIdParam)) {
      $accommodation.selectedIndex = $accommodation.options.length - 1;
    }
  });

}());
